import { render, staticRenderFns } from "./ImmersiveFullScreen.vue?vue&type=template&id=6909681a&scoped=true&"
import script from "./ImmersiveFullScreen.vue?vue&type=script&lang=js&"
export * from "./ImmersiveFullScreen.vue?vue&type=script&lang=js&"
import style0 from "./ImmersiveFullScreen.vue?vue&type=style&index=0&id=6909681a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6909681a",
  null
  
)

component.options.__file = "ImmersiveFullScreen.vue"
export default component.exports